/**
 * 槽口选择状态 Store。
 * 统一管理槽口选中状态与槽口变化事件。
 */

import { defineStore } from 'pinia';
import { EntityInteractionEventType } from '@puppycad/cad-core';
import { BehaviorSubject, type Observable, type Subscription } from 'rxjs';
import { useViewer } from '../useViewer';
import {
  observeViewerEntityInteraction,
  resolveViewerPrimarySelectedObject,
} from './viewer-selection-helpers';

//------ 槽口选择状态 开始------
/**
 * 获取当前主选中的草图槽口对象，并观测槽口变化事件。
 */
export const useGetSelectSlot = defineStore('get-select-slot', () => {
  let selectedSlot: any | null = null;
  let subscriptions: Subscription[] = [];
  let hasSubscribed = false;
  const slotChanged$ = new BehaviorSubject<any | null>(null);
  const { getViewer } = useViewer();

  

  /**
   * 从实体选择管理器同步当前选中槽口。
   */
  function syncFromManager(): void {
    selectedSlot = resolveViewerPrimarySelectedObject(getViewer());
    slotChanged$.next(selectedSlot);
  }

  /**
   * 处理槽口选中事件。
   */
  function handleSlotSelected(): void {
    syncFromManager();
  }

  /**
   * 处理选择清空事件。
   */
  function handleSelectionCleared(): void {
    selectedSlot = null;
    slotChanged$.next(null);
  }

  /**
   * 显式开始监听槽口选择事件。
   */
  function subscribe(): void {
    const viewer = getViewer();
    const slotSelected$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.SlotSelected);
    const selectionCleared$ = observeViewerEntityInteraction(viewer, EntityInteractionEventType.SelectionCleared);
    if (!slotSelected$ || !selectionCleared$ || hasSubscribed) {
      return;
    }
    syncFromManager();
    subscriptions = [
      slotSelected$.subscribe(handleSlotSelected),
      selectionCleared$.subscribe(handleSelectionCleared),
    ];
    hasSubscribed = true;
  }

  /**
   * 取消槽口选择事件监听。
   */
  function unsubscribe(): void {
    subscriptions.forEach((subscription) => subscription.unsubscribe());
    subscriptions = [];
    hasSubscribed = false;
  }

  return {
    getSelected: (): any | null => selectedSlot,
    onChanged: (): Observable<any | null> => slotChanged$.asObservable(),
    subscribe,
    unsubscribe,
  };
});
//------ 槽口选择状态 结束------
